export default "__VITE_ASSET__DdSj843i__"